export default __webpack_public_path__ + "static/media/BS_FOOD_logo.e38e8061.png";